import { Collection, Layout, util } from '@glu/core';

import template from './fieldSearch.hbs';

function filterableColumns(column) {
  return column.get('filterable') !== false;
}

export default Layout.extend({
  template,

  ui: {
    $focusField: 'input[type=text]',
    $submitBtn: '[type=submit]',
    $clearBtn: '.btn-clear-filter',
    $fieldSelect: '[name="field-name"]',
    $fieldValue: '[name="field-value"]',
    $enumSelect: '.search-input-wrapper select',
    $removeBtn: 'button[data-control="removeFilter"]'
  },

  events: {
    submit: 'handleSubmit',
    'click @ui.$removeBtn': 'handleRemoveFilter',
    'click @ui.$clearBtn': 'handleClearFilter',
    'change @ui.$focusField': 'getSelectValue',
    'keyup @ui.$focusField': 'getSelectValue'
  },

  constructor: function (opts) {
    Layout.prototype.constructor.call(this, opts);
    if (opts && opts.model) {
      this.setField(opts.model.get('field'));
    }
    this.first = false;
    if (opts) {
      this.first = opts.first || false;
    }
  },


  disable() {
    this.disabled = true;
    this.setDisabledFromProperty();
  },

  enable() {
    this.disabled = false;
    this.setDisabledFromProperty();
  },

  setDisabledFromProperty() {
    this.ui.$focusField.removeAttr('disabled');
    this.ui.$submitBtn.removeAttr('disabled');
    this.ui.$clearBtn.removeClass('hidden');
    this.ui.$fieldSelect.removeAttr('disabled');
  },

  toggle() {
    return this.isDisabled() ? this.enable() : this.disable();
  },

  isDisabled() {
    return this.disabled === true;
  },

  focus() {
    util.defer(() => {
      if (this.isClosed) {
        return;
      }
      this.ui.$focusField.focus();
    });
  },

  serializeData() {
    let items;
    if (this.model && this.collection) {
      items = new Collection(this.collection.filter(filterableColumns));
      const obj = this.model.toJSON();
      obj.items = items.toJSON();
      return obj;
    }

    if (this.collection) {
      items = new Collection(this.collection.filter(filterableColumns));
      return {
        items: items.toJSON()
      };
    }

    return Layout.prototype.serializeData.call(this);
  },

  filterBy(field, value) {
    if (this.model.get('field') !== field) {
      return;
    }

    const filter = !util.isNullOrUndefined(value.equality) ?
      this.buildRangeFilter(field, value) :
      this.buildFilter(field, value);
    try {
      this.trigger('filter', filter);
    } catch (ex) {
      return false;
    }
    return false;
  },

  buildRangeFilter(field, value) {
    if (util.isArray(value.value)) {
      return this.buildFilter(value.value[0], value.equality, value.value[1]);
    }
    return this.buildFilter(value.value, value.equality);
  },

  handleRemoveFilter() {
    this.trigger('filter:remove', this);
  },

  handleSubmit(e) {
    e.preventDefault();

    const form = e.target;
    const field = this.model.get('field');
    // const { value } = form['field-value'];
    const { value } = form.elements['field-value']; // TODO fix this?
    const filter = this.buildFilter(field, value);
    try {
      this.trigger('filter', filter);
    } catch (ex) {
      return false;
    }
    return false;
  },

  createFilter() {
    let fieldValue = this.ui.$focusField.val() || this.ui.$enumSelect.val();
    const field = this.model.get('field');
    const isEnum = this.model.get('type') === 'enum';

    if (isEnum) {
      [fieldValue] = this.dropdown.value('id');
    }

    return this.buildFilter(field, fieldValue);
  },

  buildFilter(field, value) {
    return {
      title: this.model.get('title'),
      value,
      label: value,
      type: this.model.get('type') || 'string',
      field: field || this.field,
      filter: util.bind(this.filter, this, this.field || field, value)
    };
  },

  onRender() {
    this.getSelectValue();
  },

  setField(field) {
    this.field = field;
    this.className = this.className || 'field-set';
  },

  unsetField() {
    delete this.field;
  },

  filter(field, value, model) {
    return model.get(field) === value;
  },

  getSelectValue() {
    const selection = this.ui.$fieldValue.val();
    this.handleSubmitButton(selection);
  },

  handleSubmitButton(selection) {
    this.ui.$submitBtn.prop('disabled', !selection);
    this.ui.$clearBtn.toggleClass('hidden', !selection);
    return selection;
  },

  handleClearFilter(e) {
    e.preventDefault();

    this.trigger('filter:clear', this);
  }
});
